import { AbilityBuilder, Ability } from "@casl/ability";


export default function defineAbilityFor(user){
    const {can, build} = new AbilityBuilder(Ability);


    //obtener userAuth de localStorage
    const userAuth = JSON.parse(localStorage.getItem('authUser'));
    //si no hay userAuth, no se puede definir la capacidad
    if(!userAuth){
        return build();
    }
    const permisos = userAuth.role.permissions;



    //Define capacidades dinamicamente de acuerdo userAuth y solo permite editar lo creado por el usuario
    permisos.forEach(permiso => {
        let actionsList = permiso.actions;
        
        actionsList.forEach(singleAction => {
            // Todas las demás acciones sin condición
            can(singleAction, permiso.section_name);
            
        });
    });
 

    return build();
}